const paths = {
  listTemplate: '/contract-template/list',
  editTemplate: '/contract-template/edit'
};

export default paths;
